import api from '../api'

function secondTags(second_tags, branchId, branchName) {
  let second_tags_str = ''
  if (second_tags.length || +branchId) {
    second_tags_str += '<div class="tag">'
    second_tags.forEach(tag => {
      second_tags_str += `<a href="${api.host}/qa/tag_${tag['id']}">
        #${tag['name']}
      </a>`
    })
    if (+branchId) {
      second_tags_str += `<a class="branch-source" href="${api.host}/qa/cantonal/cantonal-index?cantonal_id=${branchId}">
        来自『${branchName}』
      </a>`
    }
    second_tags_str += '</div>'
  }
  return second_tags_str
}

function author(item, sshzv, unrewarded, paidQa) {
  let author = '<div class="author">'
  if (item.user && item.user.id) {
    author += `
      <img class="author-img" src="${qaAnonymousAvatar(
        item['user']['avatar'],
        +item['is_niming'],
        +item['is_host']
      )}" alt="用户头像">
      <a target="_blank"class="author-name"  data-user-id="${
        item['user_id']
      }" data-teacher="${item['teacher']}" href="${
      +item['is_host'] && +item['is_niming']
        ? 'javascript:;'
        : api.host + '/user/' + item.user.id
    }">
        ${qaAnonymousNickName(
          item['user']['nickname'],
          +item['is_niming'],
          +item['is_host']
        )}
      </a>
    `
  }

  if (paidQa) {
    author += '<span class="author-tag"><span>心探付费问答</span></span>'
  } else {
    if (item['user_qa_honor'] && !(+item['is_host'] && +item['is_niming'])) {
      // 有标签的作者
      let level = +item['user_qa_level']
      let teacher = +item['teacher']
      if (level < 3 || !level || teacher) {
        let mixHonor = item['user_qa_honor']
        if (teacher) {
          mixHonor = item['teacher_honor']
        }
        author += `<span class="author-tag"><span>${mixHonor}</span></span>`
      } else {
        author += `<span class="honor-icon ${'honor-icon-' + level}"></span>`
      }
    }
    author += '<span class="author-answer">的回答'
    if (
      item['show_reward'] &&
      !sshzv &&
      !(+item['is_host'] && +item['is_niming'])
    ) {
      // data-userid被打赏ID  data-objectid被打赏问题ID
      author += `
        <i class="yxlicon icon-shang award-img ${
          unrewarded ? 'unrewarded' : ''
        }" data-userid="${item['user_id']}" data-objectid="${item['id']}"></i>
      `
    }
    author += '</span>'
  }
  author += `<span class="author-time">${item['created']}</span>`
  author += '</div>'
  return author
}

function qaAnonymousAvatar($avatar, $anonymous = false, $is_host = 0) {
  let $img =
    !$avatar || ($anonymous && $is_host)
      ? 'https://ossimg.xinli001.com/20181126/012930b1f5feb6367356431b9eb03a83.jpg!80'
      : $avatar
  if ($img.slice($img.length - 3) !== '!80') {
    $img += '!80'
  }
  return $img
}

function qaAnonymousNickName($nickname, $anonymous = false, $is_host = 0) {
  return !$nickname || ($anonymous && $is_host) ? '楼主' : $nickname
}

function nl2br(str) {
  // return (str + '').replace(/(\r\n|\n\r|\r|\n)/g, '<br>')
  return str
}

module.exports = function(data, sshzv, unrewarded) {
  let answerList = ''
  data.forEach(item => {
    let paidQa = item.object_type === 'psychic_coach_pay'
    let undeblock = item.is_exchange === 0
    let href = paidQa
      ? `${api.static}/msite/index.html#/heart-search/paid-qa-${
          undeblock ? 'deblock' : 'detail'
        }/${item['question_id']}?hideNavigationBar=${undeblock ? '0' : '1'}`
      : `${api.host}/qa/${item['question_id']}`
    answerList += `<li class="recommend-content${
      paidQa ? ` paidQa${undeblock ? ' undeblock' : ''}` : ''
    }">
      <div class="title-content">
        <p class="title-wrap">
          <a target="_blank" class="title" href="${href}" title="${
      item['question_title']
    }">
            ${item['question_title']}
          </a>
          <!-- 判断星标 -->
          ${
            item['show_start']
              ? '<img class="start" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAAAXNSR0IArs4c6QAAAz5JREFUWAntVk9IFFEY/74ZW9GCokt0kQQXqehgt/7QISkIwk5BoasS9OcSEe26Bh32UOGOG1YEgYWomx0Mog5FdDCwDkG3SCIMKvTiKSktbJv5+t6sM+zMvpl94ixdfDA7731/ft/vfe973yzA2vhPGaBU1z7xBIWvCVJELzd7ljGPybBRJoxaRj2J7WBZUzaupu1EI//RH0PzC6qytijFuGLTCMV5WZiqZ4R6u7eBWfgEBDE7OsIf0Nc1Y9/w11I2VSNCVxKNsGRdYgKnOGBdaVCe/+bcDEGtdgOv5r8IXeREqLezBf5aXJh0nPF1ESRkmEzhEdRohnKN0Pi4Tql2sbvwYVITk4izUSUSAodt2JZ9lDNCqY6TQHQHtmgNmMovhrNh+N7EQQ6QZp/DUlvEl6BjFvvyE0Kv3kcIROVvhjnrNL9vCuewsRxggtKd+8E0J9nW2TSBrh/A7OibUn+lo6GejkO8xxbbEfEiZTLKG7ADIj51g/LcT0LolIhw5addIKIGWJg+4a5VJkhZ16x07goViHBt7OZzbi3xEUl22rVHHLRAY+wtIL4Wjz2XGCpkhMqDEuzisz8iwQsRaQbvmx/5cApIqqXL7TugAO9ZWX4VxQ6b6lvx7GBB6uwTEpEdCxHJp7KXUiJFApgEpHa3NUu9cZb1A6DF7qEx9FNmoirzELH/L5DJhUlHGcCjCwfEefa5C7G6W3j9/ly4rVyLdspSXW0AdlveKzdTleIS0x/h9pTD/uFpVS9hh3wrkryba6FHsBLEou03Lqs2zI2K+lIaGvY/yAHWNjKnfn5+KHkFGuEHvqJdEF8fXwkJAeepA0qf2Qj06xxYcIGztDUwXrlikr8bBvTlnwfdinIXr8RDxFHR7fO1MPM9weskN7NmR+57E+/+CR+uEdSkfPahSykRx4My3ZtgoTDD6w2OzH0jjvGxdrjrVU5COytmhudBw0FpDAruklL7CsJQIkVfGuBS8nZPxBcrLcYKPCp/ffn8ZxnkoQcIo82GwFbICFvpOl9t7jT2wHdojL4qzqP7VSKC2ZEpvujP7LAaBX5BV0NLiUgxAPcJwM9QH3+8moCR+FKyc08kQGsgChn4Bwfc7n1o08NEAAAAAElFTkSuQmCC" alt="">'
              : ''
          }
        </p>
        <!-- 有同感的需要多加个has-feel样式 -->
        <div class="author-honor" data-question_id=${item['question_id']}>
          <p><span class="number ${
            +item['is_same_feeling'] ? 'has-feel' : ''
          }">${
      item[paidQa ? 'public_listen_num' : 'same_feeling_num']
    }</span>人</p>
          <p>${paidQa ? '已旁听' : '有同感'}</p>
        </div>
      </div>

      ${secondTags(
        item['second_tags'],
        item['cantonal_id'],
        item['cantonal_name']
      )}

      ${author(item, sshzv, unrewarded, paidQa)}

      <div class="ask">
        <div class="ask-detail hide-content" href="${href}">
          <div class="yxl-editor-article">
            ${nl2br(item['answer_content'])}
          </div>
        </div>

        ${
          paidQa && undeblock
            ? `<div class="deblock">解锁查看</div>`
            : `
          <div class="switch">...全文</div>
          <div class="arrow">收起</div>
        `
        }
        
      </div>

      <div class="ask-btn">
        <div class="ask-common ask-btn-comment" data-answer-id="${item['id']}">
          <i class="yxlicon icon-comment"></i>
          <span class="number">评论 <span>${item['replynum']}</span></span>
        </div>
        <div class="ask-common ask-btn-use" data-answer-id="${item['id']}">
          <!-- 哪个是用户选择的，哪个class=show -->
          <i attr-id="no-use" class="${
            +item['is_zan'] === 0 ? 'show' : 'hide'
          } yxlicon icon-youyong"></i>
          <i attr-id="used" class="${
            +item['is_zan'] === 1 ? 'show' : 'hide'
          } yxlicon icon-xuanzhong"></i>
          <span class="number ${
            +item['is_zan'] === 1 ? 'isUseful' : ''
          }">有用 <span class="detail-number">${item['votenum']}</span></span>
        </div>
        ${
          paidQa
            ? ''
            : `
          <div class="ask-common ask-btn-share answer">
            <i class="yxlicon icon-more"></i>
            <span class="number" 
              data-nickname="${
                item['user'] && item['user']['nickname']
                  ? item['user']['nickname']
                  : ''
              }"
              data-avatar="${
                item['user'] && item['user']['avatar']
                  ? item['user']['avatar']
                  : ''
              }"
              data-title="${item['title']}"
              data-cover="${item['share']['cover']}"
              data-content="${Base64.encode(nl2br(item['share']['content']))}"
              data-desc="${nl2br(item['share']['description'])}"
              data-url="${item['share']['url']}"
              data-share-url="${item['share']['share_url']}>"
            >分享</span>
          </div>
        `
        }
      </div>

      <div class="comment-content">
        <div class="input-comment" data-answer-id="${item['id']}">
          <input type="text" placeholder="回复评论">
        </div>
      </div>

      <div class="footer"></div>
    </li>`
  })
  return answerList
}



// WEBPACK FOOTER //
// ./src/pages/ask/askIndex/render/answerList.js